import { render } from "./game-play-msg-box.vue?vue&type=template&id=4e5a6142&scoped=true&ts=true"
import script from "./game-play-msg-box.vue?vue&type=script&lang=ts"
export * from "./game-play-msg-box.vue?vue&type=script&lang=ts"

import "./game-play-msg-box.vue?vue&type=style&index=0&id=4e5a6142&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5a6142"]])

export default __exports__